export default __webpack_public_path__ + "static/media/NIAS0430.34I-30937_-25067_0.4038491d.jpg";